($ => {
    function setTabActive(index) {
        closeTabs();
        $(`.featuredcategories__tab.__${index}`).addClass('active');
        $(`.featuredcategories__category.__${index}`).addClass('active');
    }
    function closeTabs() {
        $('.featuredcategories__tab').removeClass('active');
        $('.featuredcategories__category').removeClass('active');
    }
    $(() => {
        // Check if block element found on page.
        if (!$('.featuredcategories').length) {
            return;
        }
        // Show first tab.
        setTabActive(0);
        // Click to change tab.
        $('.featuredcategories__tab').on('click', function (e) {
            const index = $(this).data('index');
            setTabActive(index);
        });
        // Click to change tab.
        $('.featuredcategories__category__close').on('click', function (e) {
            closeTabs();
        });
    });
})(jQuery);
